export const translations = {
  es: {
    // Profile data
    title: 'Security Researcher & Software Engineer',
    location: 'España',
    about: `Security Researcher y Software Engineer con más de 4 años de experiencia profesional en desarrollo de software, enfocado actualmente en seguridad ofensiva, investigación de vulnerabilidades y explotación de sistemas.

Mi trayectoria como desarrollador me permite abordar la seguridad desde una perspectiva técnica: comprender cómo se diseñan e implementan los sistemas, identificar debilidades en su arquitectura y analizar las condiciones que permiten su explotación.

Mi principal interés no es únicamente utilizar herramientas ofensivas, sino entender qué ocurre detrás de cada vulnerabilidad, investigar su causa raíz y desarrollar técnicas o soluciones adaptadas a cada escenario.

🛡️ OFFENSIVE SECURITY & RED TEAMING

Especial interés en la seguridad de infraestructuras empresariales, entornos Windows y Active Directory.

• Active Directory: Kerberos, NTLM, ADCS, ACL Abuse, delegaciones y relaciones de confianza entre dominios.
• Red Team Operations: Command & Control (C2), movimiento lateral, pivoting, escalada de privilegios y post-explotación.
• Windows Internals: Tokens, privilegios, autenticación, DPAPI y mecanismos internos de seguridad.
• Enterprise Security: Análisis de superficies de ataque en tecnologías como ADFS, SCCM y Exchange.

🔬 VULNERABILITY RESEARCH & EXPLOIT DEVELOPMENT

Investigación independiente de vulnerabilidades, incluyendo el descubrimiento y reporte de fallos de seguridad identificados mediante CVE.

Mis áreas de interés incluyen:
• Binary Exploitation y Memory Corruption.
• Reverse Engineering y análisis de binarios ELF/PE.
• Investigación de vulnerabilidades y Root Cause Analysis.
• Desarrollo de Proofs of Concept (PoC).
• Exploit Development y análisis de mitigaciones.

💻 SOFTWARE ENGINEERING

Experiencia profesional en desarrollo Full-Stack con Java, Spring Boot, SQL, APIs REST y arquitecturas de microservicios.

Combino esta experiencia con investigación de seguridad y formación práctica en laboratorios avanzados de Red Team, simulando escenarios de compromiso de infraestructuras corporativas y ataques de múltiples etapas.

Mi objetivo es seguir especializándome en seguridad ofensiva e investigación de vulnerabilidades, combinando conocimientos de ingeniería de software, sistemas operativos y técnicas avanzadas de explotación.

🎯 Red Teaming · Vulnerability Research · Active Directory Security · Exploit Development · Windows Internals · Reverse Engineering · Offensive Security`,
    
    // Experience
    experienceData: [{
      company: 'Alten',
      position: 'Desarrollador de Software',
      location: 'Madrid',
      period: 'jul. 2022 - Actualidad',
      current: true,
      responsibilities: [
        'Desarrollo y mantenimiento de aplicaciones web y multiplataforma utilizando tecnologías como Java, JSF/JSP, HTML, CSS y JavaScript, asegurando funcionalidad y usabilidad',
        'Implementación eficiente de microservicios con Spring Boot y diseño de API REST, facilitando la integración y escalabilidad de sistemas',
        'Gestión de contenedores Docker para optimizar los despliegues, mejorando la eficiencia y la consistencia en diferentes entornos',
        'Aplicación de patrones de diseño MVC para estructurar código de manera eficaz y mantenible, mejorando la arquitectura de las aplicaciones',
        'Realización de pruebas unitarias con JUnit y Mockito para garantizar la calidad y el rendimiento del software',
        'Optimización de procesos internos, contribuyendo a la eficiencia operativa y a la mejora continua',
        'Fortalecimiento de la seguridad en las aplicaciones, asegurando la protección de datos y la confianza de los usuarios',
        'Dominio de tecnologías clave para el desarrollo de software como Java, SQL, Hibernate, JavaScript, XHTML, Spring, HTML, CSS, JSF/JSP, Spring Boot, API REST y Docker'
      ]
    }],
    
    // Education
    educationData: [
      {
        institution: 'Universidad Internacional de La Rioja (UNIR)',
        degree: 'Grado en Ciberseguridad',
        location: 'Madrid',
        period: '2022 - 2028',
        status: 'En curso',
        description: 'Formación especializada en seguridad informática, análisis de vulnerabilidades, pentesting y protección de sistemas.'
      },
      {
        institution: 'I.E.S JUAN DE LA CIERVA',
        degree: 'Grado Superior en Desarrollo de Aplicaciones Multiplataforma',
        location: 'Madrid',
        period: '2020 - 2022',
        status: 'Completado',
        description: 'Formación profesional en desarrollo de aplicaciones para múltiples plataformas.'
      }
    ],
    
    // Certifications
    certificationsData: [{
      id: 1,
      name: 'Certificación Profesional Ejército del Aire y del Espacio',
      issuer: 'Ministerio de Defensa - Centro de Informática de Gestión EA',
      date: '2022 - 2025',
      description: 'Certificación oficial como Programador Senior en proyectos de desarrollo Java EE para el Ejército del Aire. Experiencia en sistemas de gestión logística de aeronaves, gestión aeronáutica y calendarios integrales. Dominio de frameworks: Spring, Hibernate, CDI, JPA, PrimeFaces, JSF. Herramientas: Jira, Tomcat, WebLogic, Maven, GitLab, JUnit.',
      downloadable: true,
      filename: 'cert_ea_alten_2022_2025.pdf',
      realPDF: true
    },
    {
      id: 2,
      name: 'SOC 101 - Centro de Operaciones de Seguridad',
      issuer: 'Academia de Ciberseguridad',
      date: '2025-11-20',
      description: 'Certificado de reconocimiento por completar satisfactoriamente el curso de 15 horas académicas en modalidad online. Competencia demostrada en fundamentos del monitoreo, detección, análisis y respuesta ante incidentes de ciberseguridad. Habilidades clave para operar dentro de un Security Operations Center (SOC) moderno, alineado a marcos internacionales como MITRE ATT&CK, NIST y ISO 27035.',
      downloadable: true,
      filename: 'cert_soc101_2025.pdf',
      realPDF: true,
      pdfUrl: '/documents/certification.pdf'
    }],
    
    // UI Messages
    welcome: 'Bienvenido al Portfolio Terminal de',
    helpText: 'Escribe "help" para ver los comandos disponibles.',
    navText: 'O usa los botones de navegación abajo para explorar visualmente.',
    tipText: '💡 Tip: Prueba comandos especiales como "matrix", "hack", "quote" o "github"',
    commandsAvailable: 'Comandos disponibles:',
    showing: 'Mostrando sección:',
    aboutMe: 'Sobre mí',
    experience: 'Experiencia',
    education: 'Educación',
    certifications: 'Certificaciones',
    skills: 'Habilidades',
    contact: 'Contacto',
    opening: 'Abriendo GitHub profile...',
    repo: 'Repositorio destacado: CTF & Hack The Box challenges',
    matrixMode: '🟢 Iniciando Matrix Mode...\n[████████████████████] 100%\nMatrix Mode activado temporalmente. Usa "clear" para salir.',
    hackAttack: 'Iniciando ataque a',
    hackSteps: '[•] Escaneando puertos...\n[•] Detectando vulnerabilidades...\n[✓] Exploit encontrado: CVE-2024-XXXX\n[•] Ejecutando payload...\n[✓] Acceso obtenido a',
    hackWarning: '[!] ADVERTENCIA: Esto es una simulación :)',
    sudoPrompt: '[sudo] contraseña para',
    passwordIncorrect: 'Contraseña incorrecta. Intento denegado.',
    accessGranted: '✓ Acceso concedido. Abriendo panel de administración...',
    commandNotFound: 'comando no encontrado. Escribe \'help\' para ver comandos disponibles.',
    footer: 'Portfolio Terminal v3.1.0 | Seguridad Máxima Activada 🔒',
    footerTip: 'Tip: Prueba comandos como \'ls\', \'whoami\', \'help\' o navega con los botones',
    languageChanged: '🌐 Idioma cambiado a Español',
    currentStatus: 'ACTUAL',
    ongoing: 'En curso',
    completed: 'Completado',
    downloadPDF: 'Descargar PDF',
    note: 'Nota',
    noteText: 'Actualmente cursando el Grado en Ciberseguridad en UNIR, lo que me permite mantenerme actualizado con las últimas tendencias en seguridad informática y desarrollo seguro.',
    inProgress: 'En proceso',
    inProgressText: 'Preparando certificaciones profesionales en pentesting y ethical hacking.',
    
    // Web3 Security Content
    web3Title: '🔐 WEB3 SECURITY & BUG HUNTING',
    web3Intro: 'Especialización en auditoría de Smart Contracts y Bug Bounty hunting',
    web3Platforms: '📋 Plataformas',
    web3PlatformsList: '• Immunefi - Bug Bounty Platform\n• Cantina - Security Audits & Competitions',
    web3Tech: '⚙️ Stack Tecnológico',
    web3TechList: '• Solidity - Smart Contract Development\n• Rust - High-performance blockchain apps\n• Foundry - Testing & Development Framework',
    web3Focus: '🎯 Áreas de Enfoque',
    web3FocusList: '• DeFi Protocols\n• NFT Smart Contracts\n• DAOs & Governance\n• Cross-chain Bridges\n• Token Economics',
    web3Status: '📊 Estado',
    web3StatusText: 'Aprendizaje activo | 0 payouts (de momento) | Reportando vulnerabilidades',
    web3Scan: 'Iniciando Web3 Vulnerability Scanner...',
    
    // Commands
    commands: {
      help: 'Muestra todos los comandos disponibles',
      ls: 'Lista las secciones disponibles',
      clear: 'Limpia la terminal',
      about: 'Muestra información sobre mí',
      experience: 'Muestra mi experiencia laboral',
      education: 'Muestra mi formación académica',
      certifications: 'Muestra mis certificaciones',
      skills: 'Muestra mis habilidades técnicas',
      contact: 'Muestra información de contacto',
      whoami: 'Muestra información básica',
      github: 'Abre mi perfil de GitHub',
      linkedin: 'Abre mi perfil de LinkedIn',
      research: '🔎 Vulnerability research: hallazgos certificados (c4sh3r.dev)',
      htb: '🎯 Muestra logros de HackTheBox',
      matrix: 'Activa el efecto Matrix',
      hack: 'Simula un proceso de hacking',
      quote: 'Muestra una cita de hacking/tech',
      lang: 'Cambia el idioma (es/en)',
      cat: 'Lee el contenido de un archivo',
      web3: '🔐 Muestra experiencia en Web3 Security (usa "web3 scan" para modo interactivo)',
      ctf: '🚩 Lanza el ANDR31 Mini CTF Challenge (8 retos)'
    }
  },
  en: {
    // Profile data
    title: 'Security Researcher & Software Engineer',
    location: 'Spain',
    about: `Security Researcher and Software Engineer with over 4 years of professional experience in software development, currently focused on offensive security, vulnerability research and systems exploitation.

My background as a developer lets me approach security from a technical angle: understanding how systems are designed and implemented, spotting weaknesses in their architecture, and analysing the conditions that make exploitation possible.

What interests me is not simply running offensive tooling, but understanding what happens behind each vulnerability, investigating its root cause, and building techniques or solutions suited to each scenario.

🛡️ OFFENSIVE SECURITY & RED TEAMING

Particular focus on enterprise infrastructure security, Windows environments and Active Directory.

• Active Directory: Kerberos, NTLM, ADCS, ACL abuse, delegation and cross-domain trust relationships.
• Red Team Operations: Command & Control (C2), lateral movement, pivoting, privilege escalation and post-exploitation.
• Windows Internals: Tokens, privileges, authentication, DPAPI and internal security mechanisms.
• Enterprise Security: Attack-surface analysis of technologies such as ADFS, SCCM and Exchange.

🔬 VULNERABILITY RESEARCH & EXPLOIT DEVELOPMENT

Independent vulnerability research, including the discovery and disclosure of security flaws assigned a CVE.

My areas of interest include:
• Binary Exploitation and Memory Corruption.
• Reverse Engineering and ELF/PE binary analysis.
• Vulnerability research and Root Cause Analysis.
• Proof of Concept (PoC) development.
• Exploit Development and mitigation analysis.

💻 SOFTWARE ENGINEERING

Professional experience in Full-Stack development with Java, Spring Boot, SQL, REST APIs and microservice architectures.

I pair that experience with security research and hands-on practice in advanced Red Team labs, simulating corporate infrastructure compromise and multi-stage attacks.

My goal is to keep specialising in offensive security and vulnerability research, combining software engineering, operating systems and advanced exploitation techniques.

🎯 Red Teaming · Vulnerability Research · Active Directory Security · Exploit Development · Windows Internals · Reverse Engineering · Offensive Security`,
    
    // Experience
    experienceData: [{
      company: 'Alten',
      position: 'Software Developer',
      location: 'Madrid',
      period: 'Jul. 2022 - Present',
      current: true,
      responsibilities: [
        'Development and maintenance of web and multiplatform applications using technologies such as Java, JSF/JSP, HTML, CSS and JavaScript, ensuring functionality and usability',
        'Efficient implementation of microservices with Spring Boot and REST API design, facilitating system integration and scalability',
        'Management of Docker containers to optimize deployments, improving efficiency and consistency across different environments',
        'Application of MVC design patterns to structure code effectively and maintainably, improving application architecture',
        'Execution of unit tests with JUnit and Mockito to ensure software quality and performance',
        'Optimization of internal processes, contributing to operational efficiency and continuous improvement',
        'Strengthening application security, ensuring data protection and user trust',
        'Mastery of key technologies for software development such as Java, SQL, Hibernate, JavaScript, XHTML, Spring, HTML, CSS, JSF/JSP, Spring Boot, REST API and Docker'
      ]
    }],
    
    // Education
    educationData: [
      {
        institution: 'International University of La Rioja (UNIR)',
        degree: 'Bachelor\'s Degree in Cybersecurity',
        location: 'Madrid',
        period: '2022 - 2028',
        status: 'Ongoing',
        description: 'Specialized training in computer security, vulnerability analysis, pentesting and systems protection.'
      },
      {
        institution: 'I.E.S JUAN DE LA CIERVA',
        degree: 'Higher Degree in Multiplatform Application Development',
        location: 'Madrid',
        period: '2020 - 2022',
        status: 'Completed',
        description: 'Professional training in application development for multiple platforms.'
      }
    ],
    
    // Certifications
    certificationsData: [{
      id: 1,
      name: 'Professional Certification Air Force and Space',
      issuer: 'Ministry of Defense - Air Force IT Management Center',
      date: '2022 - 2025',
      description: 'Official certification as Senior Programmer in Java EE development projects for the Air Force. Experience in aircraft logistics management systems, aeronautical management and comprehensive calendars. Framework mastery: Spring, Hibernate, CDI, JPA, PrimeFaces, JSF. Tools: Jira, Tomcat, WebLogic, Maven, GitLab, JUnit.',
      downloadable: true,
      filename: 'cert_ea_alten_2022_2025.pdf',
      realPDF: true
    },
    {
      id: 2,
      name: 'SOC 101 - Security Operations Center',
      issuer: 'Cybersecurity Academy',
      date: '2025-11-20',
      description: 'Certificate of recognition for successfully completing a 15-hour online academic course. Demonstrated competence in fundamentals of monitoring, detection, analysis and response to cybersecurity incidents. Key skills to operate within a modern Security Operations Center (SOC), aligned with international frameworks such as MITRE ATT&CK, NIST and ISO 27035.',
      downloadable: true,
      filename: 'cert_soc101_2025.pdf',
      realPDF: true,
      pdfUrl: '/documents/certification.pdf'
    }],
    
    // UI Messages
    welcome: 'Welcome to the Terminal Portfolio of',
    helpText: 'Type "help" to see available commands.',
    navText: 'Or use the navigation buttons below to explore visually.',
    tipText: '💡 Tip: Try special commands like "matrix", "hack", "quote" or "github"',
    commandsAvailable: 'Available commands:',
    showing: 'Showing section:',
    aboutMe: 'About Me',
    experience: 'Experience',
    education: 'Education',
    certifications: 'Certifications',
    skills: 'Skills',
    contact: 'Contact',
    opening: 'Opening GitHub profile...',
    repo: 'Featured repository: CTF & Hack The Box challenges',
    matrixMode: '🟢 Starting Matrix Mode...\n[████████████████████] 100%\nMatrix Mode activated temporarily. Use "clear" to exit.',
    hackAttack: 'Starting attack on',
    hackSteps: '[•] Scanning ports...\n[•] Detecting vulnerabilities...\n[✓] Exploit found: CVE-2024-XXXX\n[•] Executing payload...\n[✓] Access gained to',
    hackWarning: '[!] WARNING: This is a simulation :)',
    sudoPrompt: '[sudo] password for',
    passwordIncorrect: 'Incorrect password. Access denied.',
    accessGranted: '✓ Access granted. Opening administration panel...',
    commandNotFound: 'command not found. Type \'help\' to see available commands.',
    footer: 'Terminal Portfolio v3.1.0 | Maximum Security Activated 🔒',
    footerTip: 'Tip: Try commands like \'ls\', \'whoami\', \'help\' or navigate with buttons',
    languageChanged: '🌐 Language changed to English',
    currentStatus: 'CURRENT',
    ongoing: 'Ongoing',
    completed: 'Completed',
    downloadPDF: 'Download PDF',
    note: 'Note',
    noteText: 'Currently pursuing a Degree in Cybersecurity at UNIR, which allows me to stay updated with the latest trends in computer security and secure development.',
    inProgress: 'In progress',
    inProgressText: 'Preparing professional certifications in pentesting and ethical hacking.',
    
    // Web3 Security Content
    web3Title: '🔐 WEB3 SECURITY & BUG HUNTING',
    web3Intro: 'Specialization in Smart Contract auditing and Bug Bounty hunting',
    web3Platforms: '📋 Platforms',
    web3PlatformsList: '• Immunefi - Bug Bounty Platform\n• Cantina - Security Audits & Competitions',
    web3Tech: '⚙️ Tech Stack',
    web3TechList: '• Solidity - Smart Contract Development\n• Rust - High-performance blockchain apps\n• Foundry - Testing & Development Framework',
    web3Focus: '🎯 Focus Areas',
    web3FocusList: '• DeFi Protocols\n• NFT Smart Contracts\n• DAOs & Governance\n• Cross-chain Bridges\n• Token Economics',
    web3Status: '📊 Status',
    web3StatusText: 'Active learning | 0 payouts (so far) | Reporting vulnerabilities',
    web3Scan: 'Starting Web3 Vulnerability Scanner...',
    
    // Commands
    commands: {
      help: 'Shows all available commands',
      ls: 'Lists available sections',
      clear: 'Clears the terminal',
      about: 'Shows information about me',
      experience: 'Shows my work experience',
      education: 'Shows my academic background',
      certifications: 'Shows my certifications',
      skills: 'Shows my technical skills',
      contact: 'Shows contact information',
      whoami: 'Shows basic information',
      github: 'Opens my GitHub profile',
      linkedin: 'Opens my LinkedIn profile',
      research: '🔎 Vulnerability research: certified findings (c4sh3r.dev)',
      htb: '🎯 Shows HackTheBox achievements',
      matrix: 'Activates Matrix effect',
      hack: 'Simulates a hacking process',
      quote: 'Shows a hacking/tech quote',
      lang: 'Changes language (es/en)',
      cat: 'Reads file content',
      web3: '🔐 Shows Web3 Security experience (use "web3 scan" for interactive mode)',
      ctf: '🚩 Launch ANDR31 Mini CTF Challenge (8 challenges)'
    }
  }
};
